import { useState } from 'react'
import { BotUserId, BotUserId2 } from '@/constants'
import { cn } from '@/lib/utils'
import { useHallUsers } from '@/contexts/HallUsersProvider'

const ProfileImage = ({ user, className = '' }) => {
  const [hasError, setHasError] = useState(false)
  const { isBot } = useHallUsers()

  const imageSrc = isBot(user) ? `/bots/${user?.imageUrl}` : user?.imageUrl

  const initials = user?.displayName?.charAt(0)?.toUpperCase() || '?'

  return hasError || !imageSrc ? (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-muted text-muted-foreground font-semibold w-full h-full',
        className,
        'aspect-square',
      )}
    >
      {initials}
    </div>
  ) : (
    <img
      src={imageSrc}
      alt={initials}
      onError={() => setHasError(true)}
      className={cn('object-cover', className)}
    />
  )
}

export default ProfileImage
